import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import AuthCallback from "@/components/AuthCallback";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Guards from "@/pages/Guards";
import Shifts from "@/pages/Shifts";
import Sites from "@/pages/Sites";
import Templates from "@/pages/Templates";
import Activity from "@/pages/Activity";
import CheckIn from "@/pages/CheckIn";
import Scan from "@/pages/Scan";
import PrintCheckpoints from "@/pages/PrintCheckpoints";
import { Toaster } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback (session_id arrives as URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/checkin/:token" element={<CheckIn />} />
      <Route path="/scan/:token" element={<Scan />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/shifts" element={<Shifts />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/guards" element={<Guards />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/sites/:siteId/print" element={<PrintCheckpoints />} />
        <Route path="/activity" element={<Activity />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
